module.exports = __webpack_public_path__ + "img/bg.5d1f5fe4.png";